import React from 'react';
import { Card, CardContent } from './ui/card';
import { AlertTriangle, Construction, Scissors, XCircle } from 'lucide-react';

const ProblemSection = () => {
  const problems = [
    {
      icon: Construction,
      title: 'Acidentes e Colisões em Postes',
      description: 'Batidas de veículos ou caminhões altos arrastando a fiação afetam todas as operadoras daquela via. Se seus links dividem o mesmo poste, ambos caem juntos.',
      color: 'text-red-500'
    },
    {
      icon: AlertTriangle,
      title: 'Obras Públicas e Escavações',
      description: 'Intervenções na calçada, manutenção de redes de água/esgoto ou recapeamento asfáltico podem romper dutos subterrâneos e cabos de todas as operadoras da rua ao mesmo tempo.',
      color: 'text-orange-500'
    },
    {
      icon: Scissors,
      title: 'Intempéries e Quedas de Árvores',
      description: 'Temporais, ventanias e galhos pesados que atingem a fiação aérea causam um efeito cascata. A estrutura física inteira é danificada, interrompendo a fibra principal e a de backup.',
      color: 'text-yellow-600'
    },
    {
      icon: XCircle,
      title: 'Fiscalização e Corte de Cabos Irregulares',
      description: 'Ações de ordenamento cortam fiações clandestinas ou não identificadas nos postes. Se um dos seus links estiver em uma rede irregular, ele pode ser eliminado sem aviso prévio.',
      color: 'text-red-600'
    }
  ];

  return (
    <section id="redundancia" className="py-16 md:py-24 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16 animate-on-scroll opacity-0 translate-y-8 transition-all duration-700">
          <span className="text-sm font-semibold tracking-wider uppercase text-[#0079be] mb-2 block">
            ENTENDA O PROBLEMA
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            A Armadilha da Fibra Duplicada
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            Muitas empresas acreditam que contratar duas ou mais operadoras garante a redundância. No entanto, isso pode causar uma falsa sensação de segurança: se o caminho físico até o seu negócio é o mesmo, sua operação permanece vulnerável a uma única falha.
          </p>
        </div>

        {/* Problems Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {problems.map((problem, index) => {
            const Icon = problem.icon;
            return (
              <Card
                key={index}
                className="animate-on-scroll opacity-0 translate-y-8 transition-all duration-700 hover:shadow-xl border-t-4 border-t-[#0079be] hover:-translate-y-2 group"
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <CardContent className="p-6">
                  <div className={`w-12 h-12 rounded-lg bg-gray-100 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                    <Icon className={`w-6 h-6 ${problem.color}`} />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{problem.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">{problem.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
